import { render } from "./GlobalNavBar.vue?vue&type=template&id=f06d6f24&scoped=true"
import script from "./GlobalNavBar.vue?vue&type=script&lang=js"
export * from "./GlobalNavBar.vue?vue&type=script&lang=js"

import "./GlobalNavBar.vue?vue&type=style&index=0&id=f06d6f24&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f06d6f24"]])

export default __exports__